import { api, PartipostApiPaginationWrapper, PartipostApiResponse } from './'
import { BannerGroupState, BannerPayload, BannerState, DisableBannerPayload, CreateBannerPayload } from 'state/banners'
import { MAX_PAGE_SIZE } from 'state/review'

export const getBannerGroups = () =>
    api.get<PartipostApiResponse<PartipostApiPaginationWrapper<BannerGroupState[]>>>('banner-groups/')

export interface GetBannersRequest extends BannerPayload {
    offset?: number
}
export const getBanners = (payload: GetBannersRequest) => {
    const { bannerGroupUuid, offset } = payload
    const parameters = {
        offset,
        limit: MAX_PAGE_SIZE,
        ordering: 'status,start_time',
    }
    return api.get<PartipostApiResponse<PartipostApiPaginationWrapper<BannerState[]>>>(
        `banner-groups/${bannerGroupUuid}/banners/`,
        parameters,
    )
}

export const createBanner = (payload: CreateBannerPayload) => {
    const { bannerGroupUuid, ...parameters } = payload
    return api.post<PartipostApiResponse<BannerState>>(`banner-groups/${bannerGroupUuid}/banners/`, parameters)
}

export interface DisableBannerResponse {
    uuid: string
    disabled_at: string
}

export const disableBanner = (payload: DisableBannerPayload) => {
    const { bannerGroupUuid, bannerUuid } = payload
    const parameters = {
        action_name: 'disable',
    }
    return api.patch<PartipostApiResponse<DisableBannerResponse>>(
        `banner-groups/${bannerGroupUuid}/banners/${bannerUuid}/action/`,
        parameters,
    )
}
